import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const practica_online = {
	state: {
		titulaciones : ''
	},
	getters: {
		getTitulaciones : state => state.titulaciones
	},
	actions: {

		requestTitulaciones : ({commit,dispatch}) => {

			return new Promise((resolve, reject) => {

				axios.get('/api/Alumno/dameTitulacionesActuales').then(r => {
					if(r.data.status == 0){
						commit('setTitulaciones', r.data.datos);
					}else{
						commit('setError', r.data.status);
					}
				});	

			});

		},
		checksCIF : function({commit,dispatch},cif){

			return new Promise((resolve, reject) => {

				axios.post('/api/Alumno/compruebaCIF', {"cif":cif}).then(r => {
					if(r.data.status == 0){
						resolve(r.data.datos);
					}else{
						commit('setError', r.data.status);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});

			});			
		},
		comprobarExisteContacto : function({commit,dispatch},info){
			let data = {
				"cif" : info[0],
				"email" : info[1]
			};
			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/compruebaEmailContactoEmpresa', data).then(response => {
					if(response.data.status == 0){
						resolve(response.data)
					}else{
						commit('setCompleteError', response);
						reject(false)
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});			
		},
		solicitarPractica : function({commit,dispatch}, data){

			return new Promise((resolve, reject) => {
				axios.post('/api/Alumno/solicitudPractica', data).then(response => {
					if(response.data.status == 0){
						commit('setError', 510);
						resolve(true);
					}else{
						commit('setCompleteError', response);
						resolve(false)
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});	
		},
		comprobarExisteAlumno : function({commit,dispatch},dni){
			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/compruebaDNIalumno', {'dni':dni}).then(response => {
					if(response.data.status == 0){
						if(!!response.data.datos){
							resolve(response.data.datos);
						}else{
							reject(false);
							commit('setError', 509);	
						}
					}else{
						commit('setCompleteError', response);	
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});			
		},
		dameTitulacionesAlumno : function({commit,dispatch},dni){
			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/dameTitulacionesAlumno', {'dni':dni}).then(response => {
					if(response.data.status == 0){
						if(!!response.data.datos){
							resolve(response.data.datos);
						}else{
							reject(false);
							commit('setError', 509);	
						}
					}else{
						commit('setCompleteError', response);	
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});			
		},
		solicitarPracticaEmpresa : function({commit,dispatch}, data){

			console.log(data);

			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/solicitudPractica', data).then(response => {
					if(response.data.status == 0){
						if(!data.idSolicitudPractica){
							commit('setError', 528);
						}else{
							commit('setError', 532);
						}
						resolve(true);
					}else{
						if(response.data.status == 58){
							commit('setErrorMensaje', response.data);
						}else{
							commit('setEraseError');
							commit('setCompleteError', response);
						}
						resolve(false);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer',error.response);
				});
			});	
		},

	},
	mutations: {
		setTitulaciones : function(state, data){
			state.titulaciones = data;
		}
	}
}

export default practica_online;



// WEBPACK FOOTER //
// ./submodules/dotia-base-fp/src/store/practica-online.js